import { Component, HostListener, Input } from '@angular/core';
import { PercentageBalanceModel } from '@bt/shared/charts/chart-pie/models/percentageBalance.model';

@Component({
  selector: 'app-my-chart-pie',
  templateUrl: './chart-pie.component.html',
  styleUrls: ['./chart-pie.component.scss']
})
export class MyChartPieComponent{
  @Input() chartsData: PercentageBalanceModel[];

  chartWidth: number;
  chartHeight: number;
  pieChartData: any;

  constructor() {   
  }

  ngOnInit() {
    this.updateChartSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateChartSize();
  }

  updateChartSize() {
    const screenWidth = window.innerWidth;

    if (screenWidth < 596) {
      this.chartWidth = screenWidth * 0.6;
      this.chartHeight = screenWidth * 0.6;
    } else {
      this.chartWidth = 500;
      this.chartHeight = 500;
    }

    this.pieChartData = {
      chartType: 'PieChart',
      dataTable: [["CryptoName", "PercentageBalanceCost"],
        ...this.chartsData.map(item => [item.name, item.value])
      ],
      options: {
        title: '',
        height: this.chartHeight + 50,
        width: this.chartWidth + 50,
        chartArea: { 
          top: 10,
          left: 10,
          right: 10, 
          bottom: 40, 
          width: this.chartWidth - 20, 
          height: this.chartHeight - 20 
        },
        backgroundColor: 'transparent',
        legend: { 
          position: 'bottom',
        },
        tooltip: {
          trigger: 'selection'
        }
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/charts/chart-pie/chart-pie.component.ts